export default "__VITE_ASSET__c1vSgUD___"